/**
 * Comentários do histórico (os mesmos do Mapa e das páginas do Legado) de
 * todos os ambientes do cliente: as abas Observações e Linha do tempo os
 * mostram com autor e data. Só busca os ambientes que a contagem diz ter
 * comentário — uma consulta por ambiente comentado, não por ambiente.
 */
import { useCallback, useEffect, useMemo, useState } from "react";

import { useAuth } from "../../../../context/AuthContext";
import useContagemComentarios, { recarregarContagemComentarios } from "../../../../hooks/useContagemComentarios";
import { listarComentariosAmbiente } from "../../../../services/mapaProducao";
import { chaveAmbiente } from "../../../MapaProducao/dados/chaves";

export default function useComentariosDoCliente(cliente) {
  const { request } = useAuth();
  const totais = useContagemComentarios();
  const [comentarios, setComentarios] = useState([]);
  const chaves = useMemo(() => {
    const todas = cliente.pedidos.flatMap((p) => p.ambientes).map((a) => chaveAmbiente(a.row)).filter(Boolean);
    return [...new Set(todas)];
  }, [cliente]);
  const comComentario = chaves.filter((c) => totais[c] > 0);
  const assinatura = comComentario.map((c) => `${c}=${totais[c]}`).join("|");

  useEffect(() => {
    if (!comComentario.length) {
      setComentarios([]);
      return undefined;
    }
    let vivo = true;
    Promise.all(comComentario.map((chave) => listarComentariosAmbiente(request, chave).catch(() => [])))
      .then((listas) => {
        if (!vivo) return;
        const juntos = listas.flatMap((l) => (Array.isArray(l) ? l : l?.data || []));
        setComentarios(juntos.sort((a, b) => Date.parse(b.criado_em) - Date.parse(a.criado_em)));
      });
    return () => {
      vivo = false;
    };
    // `assinatura` resume as chaves e os totais: muda quando alguém comenta.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assinatura, request]);

  const totalPorChave = useCallback((row) => {
    const chave = chaveAmbiente(row);
    return chave ? totais[chave] || 0 : 0;
  }, [totais]);

  return { comentarios, totalPorChave, recarregar: recarregarContagemComentarios };
}
